var $3bbcff21376a0476$exports = {};
$3bbcff21376a0476$exports = {
    "removeButtonLabel": `\xcendep\u{103}rta\u{163}i`,
    "removeDescription": `Ap\u{103}sa\u{21B}i pe Delete (\u{218}tergere) pentru a elimina eticheta.`
};


export {$3bbcff21376a0476$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
